/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 23.07.13, 17:53
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


export class BasicErrorConstants {
    public static ALL_OK: number = 0;
    public static NO_PLAYER: number = 1;
}

